export default class DateUtils {

    /**
     * 将时间戳格式化为 yy-mm-dd hh:mm
     * @param {int} timestamp 
     */
    static dateFormat(timestamp) {
        var date = new Date();
        date.setTime(timestamp * 1000);

        return date.getFullYear()
            + "-" + (date.getMonth() > 8 ? (date.getMonth() + 1) : "0" + (date.getMonth() + 1))
            + "-" + (date.getDate() > 9 ? date.getDate() : "0" + date.getDate())
            + " " + (date.getHours() > 9 ? date.getHours() : "0" + date.getHours())
            + ":" + (date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes())
            + ":" + (date.getSeconds() > 9 ? date.getSeconds() : "0" + date.getSeconds());
    }

    static getCurTime() {
        return new Date().getTime();
    }

    static dateFormatMDHM(timestamp) {
        var date = new Date();
        date.setTime(timestamp * 1000);

        return (date.getMonth() > 8 ? (date.getMonth() + 1) : "0" + (date.getMonth() + 1))
            + "月" + (date.getDate() > 9 ? date.getDate() : "0" + date.getDate())
            + "日 " + (date.getHours() > 9 ? date.getHours() : "0" + date.getHours())
            + ":" + (date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes());
    }


    /**
     * 返回 hh:mm:ss的时长格式
     * @param {number} value 
     */
    static dateFormatHMS(timestamp) {
        var date = new Date();
        date.setTime(timestamp * 1000);
        let d = (date.getDate() > 9 ? date.getDate() : "0" + date.getDate())
        let h = (date.getHours() > 9 ? date.getHours() : "0" + date.getHours())
        let m = (date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes())
        return d + ":" + h + ":" + m;
    }

    /**
    * 返回 hh:mm:ss的时长格式
    * @param {number} value 
    */
    static dateFormatHM(timestamp) {
        if (!timestamp) {
            timestamp = DateUtils.getCurTime() / 1000;
        }
        var date = new Date();
        date.setTime(timestamp * 1000);
        let d = (date.getDate() > 9 ? date.getDate() : "0" + date.getDate())
        let h = (date.getHours() > 9 ? date.getHours() : "0" + date.getHours())
        let m = (date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes())
        return h + ":" + m;
    }

    /**
   * 返回 yyyy-mm-dd
   * @param {number} value 
   */
    static dateFormatYMD(timestamp, format = '-') {
        var date = new Date();
        date.setTime(timestamp * 1000);
        return date.getFullYear()
            + format + (date.getMonth() > 8 ? (date.getMonth() + 1) : "0" + (date.getMonth() + 1))
            + format + (date.getDate() > 9 ? date.getDate() : "0" + date.getDate());
    }

    /**
   * 返回 mm-dd
   * @param {number} value 
   */
    static dateFormatMD(timestamp) {
        if (!timestamp) {
            timestamp = DateUtils.getCurTime() / 1000;
        }
        var date = new Date();
        date.setTime(timestamp * 1000);
        let week = date.getDay();
        const WEEKSTR = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
        return (date.getMonth() > 8 ? (date.getMonth() + 1) : "0" + (date.getMonth() + 1))
            + "月  " + (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) + '日  ' + WEEKSTR[week];
    }


    static dateFormatMatch(timestamp) {
        var date = new Date();
        date.setTime(timestamp * 1000);
        let week = date.getDay();
        let dd = date.getDate()
        const WEEKSTR = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']

        let md = (date.getMonth() > 8 ? (date.getMonth() + 1) : "0" + (date.getMonth() + 1)) + "月" + (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) + '日'

        let today = '';
        var nowDay = new Date();
        nowDay.setTime(DateUtils.getCurTime());
        let d = nowDay.getDate()
        if (dd == d) {
            today = '今天 ';
        } else if (dd = d + 1) {
            today = '明天 ';
        }
        return today + md + ' ' + WEEKSTR[week];
    }

    /**
  * 返回 mm-dd
  * @param {number} value 
  */
    static dateFormatMDNoWeek(timestamp) {
        if (!timestamp) {
            timestamp = DateUtils.getCurTime() / 1000;
        }
        var date = new Date();
        date.setTime(timestamp * 1000);
        return (date.getMonth() > 8 ? (date.getMonth() + 1) : "0" + (date.getMonth() + 1))
            + "-" + (date.getDate() > 9 ? date.getDate() : "0" + date.getDate());
    }

    /**
     * 将时间戳格式化，
     * 1分钟内显示“刚刚”
     * 1分钟 到 1小时内 显示 N分钟前
     * 1天内显示 N小时前
     * 1周内显示 N天前
     * 其他显示 yyyy-mm-dd hh:mm
     * @param {int} timestamp 时间戳
     */
    static dateFormat1(timestamp) {
        var now = Math.round(new Date() / 1000)
        var delTime = now - timestamp
        if (delTime <= 0) {
            return "刚刚";
        }
        if (delTime > 0) {
            if (delTime <= 60) {
                return "刚刚";
            }
            if (delTime <= 60 * 60) {
                return Math.floor(delTime / 60) + "分钟前";
            }
            if (delTime <= 60 * 60 * 24) {
                return Math.floor(delTime / 60 / 60) + "小时前";
            }
            if (delTime <= 60 * 60 * 24 * 7) {
                return Math.floor(delTime / 60 / 60 / 24) + "天前";
            }
        }
        return this.dateFormatYMD(timestamp);
    }

    /**
     * 返回 hh:mm:ss的时长格式
     * @param {number} value 
     */
    static formatTime(value) {
        let h = Math.floor(value / 60 / 60);
        let m = Math.floor(value / 60 - h * 60);
        let s = Math.floor(value - (h * 60 * 60 + m * 60));

        if (h < 10) {
            h = "0" + h;
        }

        if (m < 10) {
            m = "0" + m;
        }

        if (s < 10) {
            s = "0" + s;
        }
        return `${h}:${m}:${s}`;
    }

    static formatPlayTime(playTime) {
        if (playTime > 10000) {
            let pt = Math.ceil(playTime / 10000);
            return pt + 'w';
        } else if (playTime > 1000) {
            let pt = Math.ceil(playTime / 1000);
            return pt + 'k';
        }
        return playTime;
    }

    static sameDate(sTime, dTime) {
        let st = DateUtils.dateFormatYMD(sTime);
        let dt = DateUtils.dateFormatYMD(dTime);
        return st == dt;
    }

    static isSameDate(dTime) {
        let cur = DateUtils.getCurTime();
        return DateUtils.sameDate(cur, dTime);
    }

    static getMillis(date) {
        let arr = date.split('-');
        if (arr.length != 3) return;
        let year = Number(arr[0]);
        let month = Number(arr[1]) - 1;
        let day = Number(arr[2]);
        let d = new Date(year, month, day);
        return d.getTime() / 1000;
    }

    static getDate(timestamp) {
        var date = new Date();
        date.setTime(timestamp * 1000);
        return date.getDate()
    }
}